/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_sections/CardMessage.js
 * Created:       Tue Apr 15 2025
 * Modified By:   Greg Olive
 * Last Modified: Tue Apr 22 2025
 */

import React, {useContext, useCallback, useEffect, useState} from 'react';
import {FormSection,TextField, TextArea, Select} from "@proxy/_components";
import {TranslationsContext, FormContext} from '@proxy/_contexts';
import {loadGoogleFont, isEnabled} from "@root/_utils";

export default function CardMessage() {

  const translations = useContext(TranslationsContext);

  const {
    settings,
    formData,
    formErrors,
    updateFormField,
    maxLinesReached,
    updateLineCount,
    fulfillmentType
  }  = useContext(FormContext);

  useEffect(() => {

    updateLineCount(formData.properties._gcp_message_text);

  }, [formData.properties._gcp_message_text]);

  const messageMarkup = (
    <>

      <TextField
        label={translations.from_label}
        placeholder={translations.from_placeholder}
        type={"text"}
        name="properties[_gcp_message_from]"
        onChange={(e) => {
          updateFormField("properties._gcp_message_from", e.target.value);
        }}
        error={formErrors._gcp_message_from}
        value={formData.properties._gcp_message_from || ""}
        className="gc__message-from"
      />

      {(settings?.digital?.giftcard?.enable_message === "1" || settings?.digital?.giftcard?.enable_message === true || fulfillmentType === "physical") ? (
        <>
        <Select
          label={translations.salutation_label}
          name="properties[_gcp_message_salutation]"
          onChange={(e) => {
            updateFormField("properties._gcp_message_salutation", e.target.value);
          }}
          error={formErrors._gcp_message_salutation}
          options={["", translations.salutation1, translations.salutation2, translations.salutation3, translations.salutation4]}
          value={formData.properties._gcp_message_salutation || ""}
          style={(isEnabled(settings?.global?.appearance?.allow_user_salutation_selection)) ? undefined : { display: "none" }}
        />

        <TextArea
          id="gcpCardMessage"
          label={translations.message_label}
          name="properties[_gcp_message_text]"
          disabled={maxLinesReached === true}
          onChange={(e) => {
            const currentLength = formData?.properties?._gcp_message_text?.length;
            const newLength = e?.target?.value?.length;
            if (maxLinesReached === false || newLength < currentLength) {
              updateFormField("properties._gcp_message_text", e.target.value);
            }
          }}
          value={formData.properties._gcp_message_text || ""}
        />
        {maxLinesReached === true ? (
          <p className="gc__input_field_error_message">{translations.max_lines_reached}</p>
        ) : null}
        <Select
          label={translations.message_font_label}
          name="properties[_gcp_message_font_family]"
          onChange={(e) => {
            updateFormField("properties._gcp_message_font_family", e.target.value);
            loadGoogleFont(e.target.value, "+");
          }}
          error={formErrors._gcp_message_font_family}
          options={["",...settings.available_fonts]}
          value={formData.properties._gcp_message_font_family || ""}
          style={(isEnabled(settings.global?.appearance?.allow_user_font_selection)) ? undefined : { display: "none" }}
        />
        <Select
          label={translations.signature_font_label}
          name="properties[_gcp_signature_font_family]"
          onChange={(e) => {
            updateFormField("properties._gcp_signature_font_family", e.target.value);
            loadGoogleFont(e.target.value, "+");
          }}
          error={formErrors._gcp_signature_font_family}
          options={["",...settings.available_fonts]}
          value={formData.properties._gcp_signature_font_family || ""}
          style={(isEnabled(settings.global?.appearance?.allow_user_font_selection)) ? undefined : { display: "none" }}
          />
        </>
      ) : (<></>)}
    </>
  );

  return (
    <FormSection
      title={translations.message_details_heading}
    >
      <div className={"gc__message_details_div"}>
        {messageMarkup}
      </div>
    </FormSection>
  );
};
